import {Component, OnInit} from '@angular/core';
import {LoginModel} from "../../../../../Models/login-model";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../Service/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements  OnInit {
    userData: LoginModel = new LoginModel();

    constructor(private toastr: ToastrService , private authService: AuthService , private route:Router) {

    }
    ngOnInit(): void {
        if (localStorage.getItem("token") && localStorage.getItem("user"))
            this.route.navigateByUrl("/home");
    }
    Login(loginForm:any) {
        if (!loginForm.valid) {
            return this.toastr.error('Please Enter Your Data Correct', '', {
                timeOut: 3000,
            });
        }
        this.authService.login(this.userData).subscribe((res) => {
            this.toastr.success('Welcome in Value Engineering Site', 'Success Login', {
                timeOut: 3000,
            });
            this.route.navigateByUrl("/home");
            location.reload();
        },errors=>{
            let lstErrors = Object.keys(errors.error).map(key => ({type: key, value: errors.error[key]}))
            lstErrors.forEach(res=>{
                this.toastr.error(res.value, 'Error', {
                    timeOut: 3000,
                });
            });

        });
    }
}
